// src/app/icons.module.ts
import { NgModule } from '@angular/core';
import {
  LucideAngularModule,
  BookOpen,
  Settings,
  Layers,
  HelpCircle,
  ArrowRight,
  ChevronRight,
  Wrench,
  CalendarDays,
  TriangleAlert,
  CircleArrowRight,
  CornerDownRight,
  ChartBar,
  Plus,
  CircleAlert,
  CheckCheck,
  MessageSquare,
  Save,
  Send,
  Trash,
  Check,
  Clock,
  Users,
  Funnel,
  List,
  Shield,
  ChartNoAxesGantt,
  CircleCheckBig,
  ChartPie,
  TrendingUp,
  Calendar,
  FileText,
  CircleHelp,
  FilePen,
  BellRing,
  Bell,
  CircleCheck,
  CircleX,
  X,
  OctagonX,
  MessageCircleX,
  Zap,
  Trash2,
  Eye,
  EyeOff,
  Copy,
  Database,
  Pickaxe,
  CalendarX,
  Inbox,
  CalendarCheck, 
  Info,
  Folder,
  FilterX 
} from 'lucide-angular';

@NgModule({
  imports: [
    LucideAngularModule.pick({
      BookOpen,
      Settings,
      Layers,
      HelpCircle,
      ArrowRight,
      ChevronRight,
      Wrench,
      CalendarDays,
      TriangleAlert,
      CircleArrowRight,
      CornerDownRight,
      ChartBar,
      Plus,
      CircleAlert,
      CheckCheck,
      MessageSquare,
      Save,
      Send,
      Trash,
      Check,
      Clock,
      Users,
      Funnel,
      List,
      Shield,
      ChartNoAxesGantt,
      CircleCheckBig,
      ChartPie,
      TrendingUp,
      Calendar,
      FileText,
      CircleHelp,
      FilePen,
      BellRing,
      Bell,
      CircleCheck,
      CircleX,
      X,
      OctagonX,
      MessageCircleX,
      Zap,
      Trash2,
      Eye,
      EyeOff,
      Copy,
      Database,
      Pickaxe,
      CalendarX,
      Inbox,
      CalendarCheck,
      Info,
      Folder,
      FilterX 
    }),
  ],
  exports: [LucideAngularModule],
})
export class IconsModule {}
